import Index from "../../pages/tideng/maze/index";
import Pc from "../../pages/tideng/maze/pc";

const base = "maze";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/tideng/maze.js